import { render, staticRenderFns } from "./StudentListForm.vue?vue&type=template&id=c7622d38"
import script from "./StudentListForm.vue?vue&type=script&lang=js"
export * from "./StudentListForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports